import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import RatingField from '../../form-fields/upload/rating'
import { CreationToolUploadContext } from '../manager'
import CreationToolRating from '../../../types/rating'

const Rating = styled(RatingField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadRatingField = ({ className, field }: Props) => {
    const { rating, setRating } = useContext(CreationToolUploadContext)

    return (
        <Rating
            {...{
                className,
                field,
                defaultRating: CreationToolRating.normalize(rating),
                showInstructions: true,
                onChange: setRating,
            }}
        />
    )
}

export default CreationUploadRatingField
